import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { TextSizeValue } from "@redotech/redo-web/theme/typography";
import { memo } from "react";
import { ConditionSummarySegment } from "./condition-summary";

/** Orange marks a trigger variable, gray a value it is compared against. */
const segmentBadgeColor = { variable: "orange", value: "gray" } as const;

export const ConditionSummaryText = memo(function ConditionSummaryText({
  segments,
  fontSize = "xs",
}: {
  segments: readonly ConditionSummarySegment[];
  fontSize?: TextSizeValue;
}) {
  return (
    <Flex align="center" gap="xs" wrap="wrap">
      {segments.map((segment, index) =>
        segment.kind === "text" ? (
          <Text fontSize={fontSize} key={index}>
            {segment.text}
          </Text>
        ) : (
          <RedoBadge
            color={segmentBadgeColor[segment.kind]}
            key={index}
            size="xs"
            text={segment.text}
          />
        ),
      )}
    </Flex>
  );
});
